import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import AssetInventoryChild from "./AssetInventoryChild";

const AssetInventory = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <AssetInventoryChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default AssetInventory;
